const DocumentNotificationRuleList = () =>
  import(/* webpackChunkName: "main_app" */ "./pages/ListPage.vue");
const DocumentNotificationRuleDetail = () =>
  import(/* webpackChunkName: "main_app" */ "./pages/FormPage.vue");
const DocumentNotificationRuleIndex = () =>
  import(/* webpackChunkName: "main_app" */ "./pages/IndexPage.vue");

export default [
  {
    path: "/document_notification_rule",
    component: DocumentNotificationRuleIndex,
    redirect: "/document_notification_rule/list",
    name: "document_notification_rule",
    children: [
      {
        path: "list",
        component: DocumentNotificationRuleList,
        name: "document_notification_rule.list",
      },
      {
        path: "create",
        component: DocumentNotificationRuleDetail,
        name: "document_notification_rule.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: DocumentNotificationRuleDetail,
        name: "document_notification_rule.edit",
        props: { create: false },
      },
    ],
  },
];
